const n = [
  0,
  "100%",
  674,
  738,
  904,
  968,
  1070,
  1134
];
n.sixColumnNoPadding = n[2];
n.sixColumn = n[3];
n.eightColumnNoPadding = n[4];
n.eightColumn = n[5];
n.tenColumnNoPadding = n[6];
n.tenColumn = n[7];
export {
  n as default
};
